import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f769480")

_pushScopeId("data-v-1f769480")
const _hoisted_1 = { class: "card-main-area" }
const _hoisted_2 = { class: "display-inline-block" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['card-icon', _ctx.cardMsg.enable?'enable':'', _ctx.cardMsg.type]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("b", {
        class: ['title', _ctx.cardMsg.type?'white':'']
      }, _toDisplayString(_ctx.cardMsg.title), 3),
      _createVNode("div", {
        class: ['icon-content', _ctx.cardMsg.type?'white':'']
      }, [
        _createVNode("img", {
          src: _ctx.cardMsg.icon
        }, null, 8, ["src"]),
        _createVNode("div", null, [
          _createVNode("label", _hoisted_2, _toDisplayString(_ctx.text), 1)
        ])
      ], 2)
    ])
  ], 2))
})